import { axiosInstance } from "../Context/CreateAxios"
import { ListNotificationApi, ReadNotificationApi } from "../services/Api"
import handleError from "../utils/handleError"

export const NOTIFICATION_LIST = async (body) => {
    try {
        let response = await axiosInstance.post(ListNotificationApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}
export const READ_NOTIFICATION = async (body) => {
    try {
        let response = await axiosInstance.post(ReadNotificationApi(), body)
        return response.data
    }
    catch (error) {
        handleError(error)
    }
}